import addParametersToLink from 'utils/DOM/addParametersToLink'
import initConnectMe from 'core/controllerConnectMe'

function gapContactPage(store) {
  const hcStorage = store.hcStorage

  initConnectMe({ placement: 'step-gap-cro-page', hcStorage })

  const sherpaCroLinkEl = document.querySelector(
    '.gap-contact__partner .healthSherpa .btn'
  )
  const [sherpaCroUrl, sherpaCroParams] = sherpaCroLinkEl.href.split('?')

  sherpaCroLinkEl.href =
    sherpaCroUrl +
    addParametersToLink(sherpaCroParams, {
      utm_campaign: hcStorage.healthcareSession,
      utm_source: 'enroll.pivothealth.com'
    })
}

export default gapContactPage
